// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loginDiv{margin-top:60px;grid-area:center;display:flex;flex-direction:column;align-items:center;text-align:center;font-size:large}.margin10{margin:10px}", ""]);
// Exports
module.exports = exports;
